import axios from "axios";
import { LOCAL_URL } from "../constant";
const deleteExperience = async (id) => {
	try {
		const response = await axios.delete(`${LOCAL_URL}/space/${id}`);
		return response;
	} catch (error) {
		return error;
	}
};
export default deleteExperience;
